<template>
	<div @click.stop="setActive" class="width-100" ref="input">
		<v-list-item
			class="px-2"
			:class="{ active: isActive }"
			:link="link"
			@mouseover="hover = true"
			@mouseleave="hover = false"
		>
			<v-icon v-if="icon" color="grey darken-3" class="mr-2">
				{{ icon }}
			</v-icon>
			<v-text-field
				:placeholder="listName"
				@keydown.enter="renameList"
				@focus="$event.target.select()"
				class="input-text caption font-weight-medium mr-4"
				dense
				hide-details
				outlined
				v-click-outside="renameList"
				v-if="edit"
				v-model="newListName"
			/>
			<v-list-item-title
				v-if="!edit"
				:class="{ 'font-weight-bold': bold, tag: isTag }"
			>
				<span :style="{ background: color }">
					{{ listName }}
				</span>
			</v-list-item-title>

			<Transition name="fade">
				<div
					v-if="
						(type === 'tag' || type === 'list') &&
						hover &&
						(!tag || tag.user_id === $store.state.auth.user.id)
					"
					class="d-flex"
				>
					<v-btn
						@click.stop="toggleEdit()"
						icon
						x-small
						class="square secondary"
					>
						<v-icon>$edit</v-icon>
					</v-btn>
					<v-btn
						@click.stop="deleteItem"
						icon
						x-small
						class="square bg-red mx-2"
					>
						<v-icon color="#de1c22">$delete</v-icon>
					</v-btn>
				</div>
			</Transition>

			<div
				class="number-of-tasks font-weight-bold text-subtitle-2 px-2 py-1"
				:class="[numberOfTasks === 0 ? 'empty' : null]"
			>
				{{ numberOfTasks }}
			</div>
		</v-list-item>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	props: {
		listName: {
			type: String,
			required: true,
		},
		numberOfTasks: {
			type: Number,
			required: true,
		},
		bold: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: "",
		},
		link: {
			type: Boolean,
			default: true,
		},

		icon: {
			type: String,
		},
		id: {
			type: Number,
		},
		color: {
			type: String,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		tag: {
			type: Object,
		},
	},
	data() {
		return {
			hover: false,
			edit: false,
			newListName: "",
		};
	},

	computed: {
		isTag() {
			return this.type === "tag" ? true : false;
		},
		isList() {
			return this.type === "list" ? true : false;
		},
	},

	methods: {
		...mapActions("tasks", [
			"deleteTag",
			"updateTag",
			"deleteList",
			"updateList",
		]),

		toggleEdit() {
			this.edit = !this.edit;

			if (this.edit === true) {
				setTimeout(() => {
					this.$refs.input.querySelector("input").focus();
				}, 0);
			}
		},

		renameList() {
			this.toggleEdit();
			if (this.newListName && this.type === "list") {
				this.updateList({ id: this.id, name: this.newListName });
			}

			if (this.newListName && this.type === "tag") {
				this.updateTag({ id: this.id, name: this.newListName });
			}
		},

		deleteItem() {
			if (this.type === "tag") {
				this.deleteTag(this.id);
				this.$emit("deleteTag", this.id);
			}

			if (this.type === "list") {
				this.deleteList(this.id);
			}
		},

		setActive() {
			this.$emit("setAciveList");
		},
	},
};
</script>

<style lang="scss" scoped>
.number-of-tasks {
	color: white;
	background-color: var(--v-accent-base);
	border-radius: 8px;

	&.number-of-tasks-secondary {
		color: var(--v-accent-base);
		background-color: var(--v-secondary);
	}

	&.empty {
		color: $muted;
		background-color: var(--v-grey-lighten2);
	}
}

.square {
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 8px;

	&.bg-red {
		background-color: #ffe0e1;
	}

	* {
		width: 24px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.active {
	background: var(--v-accent-lighten2);
}

.tag {
	span {
		border-radius: 5000px;
		color: var(--v-background-base);
		font-size: 12px;
		font-weight: 600;
		letter-spacing: 0.2px;
		padding: 4px 8px;
	}
}

.v-list-item__title.tag {
	overflow: visible !important;
}
</style>
